import api, { createApiService } from "../http"
import { RequestGetAll } from "../types/services-types/http-types"
import { IRegistryPersonalities } from "../types/services-types/registry-types"

export default class RegistryPersonalitiesService {

    static apiRegistryPersonalitiesService = createApiService('/registry-personalities')

    static async AddFromExcel(formData: FormData) {
        const response = await this.apiRegistryPersonalitiesService.post<IRegistryPersonalities[]>('/add-from-excel', formData)
        return response.data
    }


    static async Add(json: Object) {
        const response = await this.apiRegistryPersonalitiesService.post<IRegistryPersonalities>('/add', json)
        return response.data
    }

    static async Update(data: Object) {
        const response = await this.apiRegistryPersonalitiesService.post<IRegistryPersonalities>(`/update`, data)
        return response.data
    }

    static async Get(id: number) {
        const response = await this.apiRegistryPersonalitiesService.get<IRegistryPersonalities>(`/${id}`)
        return response.data
    }

    static async GetAll(limit: number, page: number) {
        const response = await this.apiRegistryPersonalitiesService.get<RequestGetAll<IRegistryPersonalities[]>>('/all', {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async GetAllFilters(limit: number, page: number, form: Object) {
        const response = await this.apiRegistryPersonalitiesService.get<RequestGetAll<IRegistryPersonalities[]>>('/all-filters', {
            params: {
                ...form,
                limit,
                page
            }
        })
        return response.data
    }

    static async Delete(id: number) {
        const response = await this.apiRegistryPersonalitiesService.post(`/delete/${id}`)
        return response.data
    }
}